<app-alert-block type="info">{{ 'This is the only time these codes will be shown.' }}</app-alert-block>

<ul class="codes-grid">
    <li *ngFor="let code of codes; trackBy: trackByCode" class="code">{{ code }}</li>
</ul>

<!-- Utilities follow the codes they act on, before the divider that separates the
     acknowledge gate. -->
<div class="actions-row">
    <button type="button"
            class="code-action"
            e2eId="recovery-codes-copy"
            [copyToClipboard]="codesBlock"
            copySuccessTitle="Recovery codes copied"
            copySuccessMessage="Your recovery codes were copied to your clipboard.">
        <i class="ph-bold ph-copy" aria-hidden="true"></i> {{ 'Copy all' }}
    </button>

    <button type="button"
            class="code-action"
            e2eId="recovery-codes-download"
            (click)="download()">
        <i class="ph-bold ph-download-simple" aria-hidden="true"></i> {{ 'Download .txt' }}
    </button>

    <button type="button"
            class="code-action"
            e2eId="recovery-codes-print"
            (click)="print()">
        <i class="ph-bold ph-printer" aria-hidden="true"></i> {{ 'Print / Save as PDF' }}
    </button>
</div>

<!-- Print source for the action above (SD-8983). Hidden on screen and never rendered to the
     user directly: PrintService copies this container's INNER HTML into a print popup, so the
     container's own `display: none` does not suppress the output — only the children travel.
     That is also why the child styles live at the top level of the SCSS rather than nested
     under `.print-source`: the container does not exist in the popup, so a nested selector
     would never match there. -->
<div [id]="printId" class="print-source">
    <h1 class="print-heading">{{ 'PayHOA recovery codes' }}</h1>

    <p class="print-meta" *ngIf="accountEmail">{{ 'Account: ' }}{{ accountEmail }}</p>
    <p class="print-meta">{{ 'Generated: ' }}{{ generatedAt | legfiDate:'MMMM D, YYYY' }}</p>

    <ul class="print-codes">
        <li *ngFor="let code of codes; trackBy: trackByCode">{{ code }}</li>
    </ul>

    <p class="print-note">
        {{ 'Each code can be used once. Generating a new set invalidates every code on this sheet.' }}
    </p>
</div>

<!-- Acknowledge gate — same body placement as confirm-2fa-code's trust-device row. -->
<mat-divider></mat-divider>
<mat-checkbox
    class="acknowledge"
    e2eId="recovery-codes-acknowledge"
    [checked]="acknowledged"
    [disableRipple]="true"
    (change)="onAcknowledgedChange($event.checked)">
    {{ 'I have saved my recovery codes somewhere safe.' }}
</mat-checkbox>
